import { Trans, useTranslation } from 'react-i18next';

import { PlayTriangleIcon, InfoCircleIcon } from 'icons';
import { colors } from 'styles/colors';

import { BtnOutline, BtnPrimary } from '../../styles';
import {
  ModalOverlay, ModalBox, ModalHeader, ModalIconWrap, ModalTitle, ModalSubtitle,
  ModalListItem, ModalFooter,
} from './styles';

interface ConfirmModalProps {
  onConfirm: () => void;
  onClose: () => void;
  isStarting: boolean;
  sidebarWidth: number;
  durationMinutes: number;
}

export const ConfirmModal = ({
  onConfirm, onClose, isStarting, sidebarWidth, durationMinutes,
}: ConfirmModalProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <ModalOverlay $sidebarWidth={sidebarWidth} onClick={onClose}>
      <ModalBox onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <ModalIconWrap>
            <InfoCircleIcon size={20} />
          </ModalIconWrap>
          <div>
            <ModalTitle>{t('instrucoesValidacaoManutencao')}</ModalTitle>
            <ModalSubtitle>{t('confirmeAntesDaValidacao')}</ModalSubtitle>
          </div>
        </ModalHeader>
        <ul style={{ listStyle: 'none', margin: '0 0 24px 0', padding: 0 }}>
          <ModalListItem>
            <span><Trans i18nKey="instrucaoValidacao1" components={{ strong: <strong /> }} /></span>
          </ModalListItem>
          <ModalListItem>
            <span><Trans i18nKey="instrucaoModalValidacao2" values={{ minutes: durationMinutes }} components={{ strong: <strong /> }} /></span>
          </ModalListItem>
        </ul>
        <ModalFooter>
          <BtnOutline onClick={onClose}>{t('cancelar')}</BtnOutline>
          <BtnPrimary onClick={onConfirm} disabled={isStarting}>
            <PlayTriangleIcon color={colors.White} />
            {t('confirmarEIniciar')}
          </BtnPrimary>
        </ModalFooter>
      </ModalBox>
    </ModalOverlay>
  );
};
